import React, {useState} from 'react';
import {useFormContext} from 'react-hook-form';
import {useSelector} from 'react-redux';
import selectors from 'src/modules/modeloFormulario/modeloFormularioSelectors';
import ModeloFormularioService from 'src/modules/modeloFormulario/modeloFormularioService';
import ModeloFormularioFormModal from 'src/view/modeloFormulario/form/ModeloFormularioFormModal';
import AutocompleteInMemoryFormItem from 'src/view/shared/form/items/AutocompleteInMemoryFormItem';

function ModeloFormularioAutocompleteFormItem(props) {
  const {setValue, getValues} = useFormContext();

  const [modalVisible, setModalVisible] = useState(false);

  const hasPermissionToCreate = useSelector(selectors.selectPermissionToCreate);

  const doCloseModal = () => {
    setModalVisible(false);
  };

  const doOpenModal = () => {
    setModalVisible(true);
  };

  const doCreateSuccess = (record) => {
    const {name, mode} = props;

    if (mode && mode === 'multiple') {
      setValue(name, [...(getValues()[name] || []), record]);
    } else {
      setValue(name, record);
    }

    doCloseModal();
  };

  const fetchFn = (value, limit) => {
    if (props.filter) {
      return ModeloFormularioService.listAutocomplete({value, filter: props.filter}, limit);
    } else {
      return ModeloFormularioService.listAutocomplete(value, limit);
    }
  };

  const mapper = {
    toAutocomplete(originalValue) {
      if (!originalValue) {
        return null;
      }

      const value = originalValue.id;
      let label = originalValue.label;

      if (originalValue.nombre) {
        label = originalValue.nombre;
      }

      return {
        key: value,
        value,
        label,
        clasificacion: originalValue.clasificacion,
      };
    },

    toValue(originalValue) {
      if (!originalValue) {
        return null;
      }

      return {
        id: originalValue.value,
        label: originalValue.label,
        clasificacion: originalValue.clasificacion,
      };
    },
  };

  return (
    <>
      <AutocompleteInMemoryFormItem
        {...props}
        entity="modelo-formulario"
        fetchFn={fetchFn}
        mapper={mapper}
        onOpenModal={doOpenModal}
        hasPermissionToCreate={hasPermissionToCreate}
      />

      {modalVisible && <ModeloFormularioFormModal onClose={doCloseModal} onSuccess={doCreateSuccess} />}
    </>
  );
}

export default ModeloFormularioAutocompleteFormItem;
